export interface NcbConsent {
  applicationRef: string;
  ncbConsentInfo: string;
}
